import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { STACK } from "../content.js";

export const Stack = ({ accent }) => {
  const items = [...STACK, ...STACK];
  return (
    <section id="stack" style={{ background: C.bg, padding: "140px 0" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto 48px", padding: "0 40px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 24,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <SectionLabel accent={accent}>// EXPERTISE</SectionLabel>
            <h2
              style={{
                margin: 0,
                fontFamily: fonts.serif,
                fontSize: "clamp(36px, 4.4vw, 56px)",
                fontWeight: 500,
                color: C.fg,
                letterSpacing: "-0.01em",
                lineHeight: 1.05,
              }}
            >
              Our technical{" "}
              <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>stack.</em>
            </h2>
          </div>
          <p style={{ margin: 0, fontFamily: fonts.mono, fontSize: 13, color: C.body, maxWidth: 320 }}>
            The tools we use in production, every day.
          </p>
        </div>
      </div>
      <div
        style={{
          position: "relative",
          borderTop: `1px solid ${C.border}`,
          borderBottom: `1px solid ${C.border}`,
          padding: "28px 0",
          overflow: "hidden",
          maskImage:
            "linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%)",
        }}
      >
        <div
          className="stack-ticker"
          style={{
            display: "flex",
            gap: 0,
            whiteSpace: "nowrap",
            animation: "ticker 60s linear infinite",
            width: "max-content",
          }}
        >
          {items.map((it, i) => (
            <span key={i} style={{ display: "inline-flex", alignItems: "center" }}>
              <span
                style={{
                  fontFamily: fonts.mono,
                  fontSize: 18,
                  color: "#A0A0A0",
                  padding: "0 22px",
                  letterSpacing: "0.04em",
                }}
              >
                {it}
              </span>
              <span style={{ color: accent, fontSize: 22, lineHeight: 1 }}>·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
